import { formatPhoneNumber } from "@/helpers/phone-helpers";
import {
  CONVERSATION_REPORT_EXPORT_LIMIT,
  ConversationReportQuery,
  IConversationReportRow,
} from "@/types/conversation-report.types";

function cell(value: string | number | null | undefined) {
  const text = value == null ? "" : String(value);
  if (/[;"\n]/.test(text)) return `"${text.replace(/"/g, '""')}"`;
  return text;
}

export function buildConversationReportCsv(rows: IConversationReportRow[]): string {
  const header = [
    "Contato",
    "Telefone",
    "Plataforma",
    "Atendente",
    "Workflow",
    "Fila",
    "Assunto principal",
    "Início",
    "Última mensagem",
    "Não lidas",
    "Última interação",
    "Primeira resposta",
    "Encerramento",
    "Encerrada por humano",
    "Reativações",
    "CSAT",
    "Problema resolvido",
    "Status",
  ];

  const lines = rows.map((row) =>
    [
      row.contactName,
      row.mobilePhone ? formatPhoneNumber(row.mobilePhone) : "",
      row.platformName,
      row.userName,
      row.workflowName,
      row.queueName,
      row.mainSubjectName,
      row.startDate,
      row.lastReceivedDate,
      row.unReadMessages,
      row.lastInterationDate,
      row.firstAnswerDate,
      row.endDate,
      row.closedByHuman == null ? "" : row.closedByHuman ? "Sim" : "Não",
      row.reactivationCount,
      row.csat,
      row.issueSolved == null ? "" : row.issueSolved ? "Sim" : "Não",
      row.status,
    ]
      .map(cell)
      .join(";")
  );

  return `\uFEFF${header.join(";")}\n${lines.join("\n")}`;
}

export function downloadConversationReportCsv(content: string) {
  const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "conversas.csv";
  link.click();
  URL.revokeObjectURL(url);
}

export function isExportTruncated(totalCount: number) {
  return totalCount > CONVERSATION_REPORT_EXPORT_LIMIT;
}

export type { ConversationReportQuery };
